/* istanbul ignore file */
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { useBudgetUrl } from 'domain/shared/budget';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const BudgetBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useBudgetUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Budget" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default BudgetBreadcrumbs;
